import axios from 'axios';
import { projectApi as api } from './api';

interface ExportProjectsParams {
  url: string;
}

export const exportProjects = async (params: ExportProjectsParams) => {
  const response = await api.get(params.url, { responseType: 'blob' });
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response;
};
